export const PAGE_HEADER_MARGIN_BOTTOM = 2;
export const CARD_SECTION_GAP = 3;
export const SECTION_MARGIN_BOTTOM = 3;


